import axios from 'axios';
import { message } from 'antd';
import { ElectronSDK } from '@/electronSDK';

// TODO: 根据环境判断baseURL (electron or web)
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : '',
});

const ACCESS_TOKEN = 'Authorization';

// 异常拦截处理器
const errorHandler = (error: any) => {
  if (error?.response?.data?.message) {
    message.error(error.response.data.message);
  } else {
    message.error('Network Error you can press F12 to see more detail');
  }
  return Promise.reject(error);
};

// request interceptor
instance.interceptors.request.use((config) => {
  // const token = localStorage.getItem(ACCESS_TOKEN);
  const token = ElectronSDK.getStore(ACCESS_TOKEN);
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
}, errorHandler);

// response interceptor
instance.interceptors.response.use((response) => {
  let result = null;
  if (Number.isInteger(response.data.code)) {
    switch (response.data.code) {
      // success
      case 0:
        result = response.data;
        break;
      // fail
      default:
        result = Promise.reject(response.data);
        message.open({
          type: 'error',
          content: response.data.message,
        });
        // 未登录跳转登录页
        if (response.data.code === 401) {
          // ElectronSDK.setStore(ACCESS_TOKEN, '');
          // window.yqGlobalRouter.router.navigate('/login');
        }
        break;
    }
  } else {
    result = response.data;
  }
  return result;
}, errorHandler);

export default instance;
